const data = {
  primaryColor: "#607d8b",
  lightColor: false,
  title: "Console",
  category: "Internal Tools",
  icon: "/images/app-icons/console.png",
  slogan:
    "Monitoring servers, APIs. Managing user's accounts. Analyzing logs and crashes in applications.",
  shortDescription:
    "Simple web application for monitoring my servers, APIs, websites, registered users and Android applications. This application help me to analyze and fix crashes on Android applications. Helps me also with understanding how users are using my Android applications and also web applications.",
  fullDescription:
    "Simple web application for monitoring my servers, APIs, websites, registered users and Android applications. This application help me to analyze and fix crashes on Android applications. Helps me also with understanding how users are using my Android applications and also web applications." +
    "With monitoring of serves I know if I need to increase my resources, monitor also some suspicious activities and overall usage of my current servers. With monitoring of my APIs, I can ensure that all of my APIs are available and ready to be used. Analyzing logs from APIs and Android applications I can better fix bugs or crashes in these applications.",
  usesCases: [
    "Helping me with understanding how much my projects are used and in which ways they are used",
    "Helps me monitor resource usages",
    "Helps me monitor availability of my projects",
    "Helps me with managing users that are register in my apps",
    "Helps me with better understanding crashes or bugs that occurred in my projects",
  ],
  properties: [
    "Current usage of my servers and their availability in graphs",
    "Historical usage of my servers and their availability in graphs",
    "Current usage of my APIs and their availability  in graphs",
    "Historical usage of my APIs and their availability in graphs",
    "Showing lists of logs and http requests in APIs",
    "Showing details of logs and HTTP requests in APIs",
    "Showing lists of logs and crashes that occurred in Android Apps",
    "Showing details of logs and crashes that occurred in Android Apps",
    "Showing accounts and their details with possibility to make actions on them like deletion of account, resetting them password or block account",
    "Showing availability of ReactJS websites with visits of their pages",
    "Daily reports for Android Apps, APIs, ReactJS websites and servers to summarize daily activity and history of usage for each applications",
  ],
  services: [],
  android: null,
  frontend: {
    url: null,
    versioning: {
      releasedOn: new Date(2023, 0, 1),
      currentVersion: "0.0.6",
      updatedOn: new Date(2023, 1, 27),
    },
    languages: {
      supported: "English",
      inProgress: null,
    },
    responsivenessCompatibility: {
      phone: true,
      tablet: true,
      desktop: true,
    },
    techInformation: {
      language: "JavaScript",
      framework: "ReactJS",
      integrations: [
        {
          name: "Reporting API",
          url: "/projects/reporting-api",
          purposes: [
            "Information about Android installations, logs, crashes and daily reports",
            "Information about servers, current usage, history of usage and daily reports",
            "Information about APIs, their health, availability, resource usage, analytics about logs and http requests",
            "Information about websites, their health, availability and visits",
          ],
        },
        {
          name: "Identity API",
          url: "  /projects/identity",
          purposes: [
            "Lists of registered users",
            "Details about user",
            "Possibility to delete, blocked or reset password of user",
          ],
        },
      ],
      packageManager: "npm",
      webServer: "Nginx",
      virtualization: "Docker container",
      containerOS: "Alpine Linux",
      deployed: "k3s cluster",
    },
    images: [
      {
        title: "Main screen",
        url: "../../images/project-screenshots/console/console-web-1.png",
        description: null,
      },
    ],
  },
  backend: null,
};

class ConsoleProjectData {
  get() {
    return data;
  }

  getAsItem() {
    return {
      tag: "console",
      title: data.title,
      category: data.category,
      icon: data.icon,
      shortDescription: data.shortDescription,
      platform: {
        android: data.android !== null,
        frontend: data.frontend !== null,
        backend: data.backend !== null,
      },
    };
  }

  getIfCategoryIsMatched(categoryName) {
    if (categoryName === data.category) {
      return this.getAsItem();
    }

    return undefined;
  }
}

export default new ConsoleProjectData();
